// Vercel görsel optimizasyonu kotası dolunca (Hobby 5.000 dönüşüm/ay) `/_next/image` önbellekte olmayan
// görsellerde hata döner. Görsel kırık kalmasın ya da avatar simgeye düşmesin diye orijinal Firebase
// Storage adresine geçilir; önbellekteki optimize görseller etkilenmez. Yakalama, belge düzeyinde
// capture aşamasında yapılır: antd Avatar'ın kendi hata işleyicisi olaya ulaşmadan adres değişir.
const STORAGE_ORIGIN = 'https://firebasestorage.googleapis.com/';

export function storageFallbackUrl(src: string, base: string): string | null {
  let url: URL;
  try {
    url = new URL(src, base);
  } catch {
    return null;
  }
  if (url.pathname !== '/_next/image') return null;
  const original = url.searchParams.get('url');
  return original && original.startsWith(STORAGE_ORIGIN) ? original : null;
}

export function installImageFallback(): () => void {
  const onError = (event: Event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || image.dataset.storageFallback) return;
    const original = storageFallbackUrl(image.currentSrc || image.src, window.location.href);
    if (!original) return;
    event.stopPropagation();
    image.dataset.storageFallback = '1';
    image.removeAttribute('srcset');
    image.src = original;
  };
  document.addEventListener('error', onError, true);
  return () => document.removeEventListener('error', onError, true);
}
